import { render, staticRenderFns } from "./PreviousTripItinerary.vue?vue&type=template&id=aaeafd20&"
import script from "./PreviousTripItinerary.vue?vue&type=script&lang=js&"
export * from "./PreviousTripItinerary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports